export enum AsideBusEvents {
  IgnoreMouseOut = 'IgnoreMouseOut',
  ListenForMouseOut = 'ListenForMouseOut',
}

export type AsideBusEventPayloads = {
  [AsideBusEvents.IgnoreMouseOut]: void;
  [AsideBusEvents.ListenForMouseOut]: void;
};
